import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import { compile } from "@bd-utils/handlerbars-helper";

export class Block_End extends BD_Block {
  constructor() {
    super();

    this.type = "end";
    this.templateID = "end-template";

    this.elms = {
      showRating: ".js-show-rating",
      closeModal: ".modal__closeBtn",
      inputRating: "input[type=radio][name=experience]",
      submitRating: ".submitExperienceButton",
      replayBtn: "#replayButton",
      rateSlider: ".js-rating-slider",
      closeRatingSlider: ".js-close-popup",
      leaderboardBtn: "#goToLeaderboard",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.audio = false;
    this.slidingVal = 0;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.replayBtn,
        handler: this.onReplay,
      },
      {
        event: "click",
        selector: elms.showRating,
        handler: this.onShowRating,
      },
      {
        event: "click",
        selector: elms.closeModal,
        handler: this.onCloseModal,
      },
      {
        event: "click",
        selector: elms.inputRating,
        handler: this.onSelectRating,
      },
      {
        event: "click",
        selector: elms.submitRating,
        handler: this.onSubmitRating,
      },
      {
        event: "input",
        selector: elms.rateSlider,
        handler: this.onSlidingRate,
      },
      {
        event: "click",
        selector: elms.closeRatingSlider,
        handler: this.onToggleSliderRating,
      },
      {
        event: "click",
        selector: elms.leaderboardBtn,
        handler: this.onGoToLeaderboard,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.setGameState();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();
    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);
    $(".gameScreen")
      .removeClass("is-active")
      .filter("#endScreen")
      .addClass("is-active");

    const showRating = () => {
      if (CONFIG.game_options.rating_type === "none") return;

      setTimeout(() => {
        if (CONFIG.game_options.rating_type === "slider") {
          $("#slider-rating").addClass("is-opened");
          this.onSlidingRate({}, $(this.elms.rateSlider));
        } else if (CONFIG.game_options.rating_type === "standard") {
          $("#default-rating").addClass("is-opened");
        }
      }, 1500);
    };

    showRating();
  }

  setGameState() {}

  /* ========= ELEMENT FUNCTION HANDLER ===============*/

  onToggleSliderRating() {
    const hasOpen = $(".ratingPopup").hasClass("is-opened");
    const isOpen = !hasOpen;
    $(".ratingPopup").toggleClass("is-opened", isOpen);
  }

  onReplay(e, $el) {
    $el.attr("disabled", true);

    bdapi
      .post("member/reset-active-game-progress", {})
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        // console.log("err", err);
        $el.removeAttr("disabled");
      });
  }

  onSlidingRate(e, $el) {
    const bubble = $(".inputSlider__thumb .value");
    const thumb = $(".inputSlider__thumb");
    const val = $el.val();
    const minValue = 1;

    if (val < minValue) {
      $el.val(minValue);
      return;
    }

    const min = $el.prop("min");
    const max = $el.prop("max");
    const newVal = Number(((val - min) * 100) / (max - min));
    // @ts-ignore
    bubble.innerHTML = val;

    bubble.html(val);
    thumb.css("left", newVal + "%");
  }

  onShowRating() {
    $(".ratingPopup").addClass("is-opened");
  }

  onCloseModal() {
    $("#page").removeClass("is-modal");
  }

  onSelectRating() {
    $(this.elms.submitRating).prop("disabled", false);
  }

  onSubmitRating(e, $el) {
    $el.prop("disabled", true);
    var ratingValue;

    if (CONFIG.game_options.rating_type === "slider") {
      const $el = $(".js-rating-slider");
      const val = $el.val();
      const max = $el.prop("max");
      ratingValue = "slider," + val + "/" + max;
    } else if (CONFIG.game_options.rating_type === "standard") {
      ratingValue = $(this.elms.inputRating.concat(":checked")).val();
    }
    // console.log("submit ratingValue", ratingValue);

    bdapi
      .post("game/submit-rating", { rating_value: ratingValue })
      .then((response) => {
        const status = response.status;
        $("#page").removeClass("is-modal");
        $(".ratingPopup").removeClass("is-opened");
        if (status !== 200) {
          return;
        }
      })
      .catch(() => {});
  }

  onGoToLeaderboard() {
    window.location.href = "/leaderboard";
  }
}
